<div>
    <app-header-side>
    </app-header-side>
    <router-outlet></router-outlet>
</div>